import { createSlice } from "@reduxjs/toolkit";

export const initialPlanLocalState = {
  subscriptionPlan: {
    plan_name: "",
    price: "",
    durations: "",
    discount: "",
    features: "",
  },
};
export const servicePlansSlice = createSlice({
  name: "ServicePlans",
  initialState: {
    plans: [],
    features: [],
    planSubscriberUserList: [],
    isPlanResponse: false,
    isPlanError: false,
    newPlanLocal: initialPlanLocalState,
  },
  reducers: {
    getAllPlans: (state) => {},
    setAllPlans: (state, { payload }) => {
      console.log("plan-payload", payload);
      state.plans = payload;
    },

    getAllFeatures: (state) => {},
    setAllFeatures: (state, { payload }) => {
      console.log("feature-payload", payload);
      state.features = payload;
    },

    updatePlans: (state, { payload }) => {
      console.log("updatePlans", payload);
    },
    updatePlanResponse: (state, { payload }) => {
      console.log("response-payload", payload);
      state.isPlanResponse = payload;
    },
  
    updateSinglePlanAction: (state, { payload }) => {},

    updatePlanError: (state, { payload }) => {
      console.log("error-payload", payload);
      state.isPlanError = payload;
    },
    
    getAllPlanById: (state, { payload }) => {},
    setNewPlanLocal: (state, action) => {
      console.log("action",action);
      state.newPlanLocal = {
        ...state.newPlanLocal,
        ...action.payload,
      };
      
    },

    resetNewPlanLocal: (state) => {
      state.newPlanLocal = initialPlanLocalState;
    },

    updateNewPlanLocalField: (state, { payload }) => {
      const { field, value } = payload;
      state.newPlanLocal.subscriptionPlan[field as keyof typeof state.newPlanLocal.subscriptionPlan] = value;
    },

    getPlanSubscriberUserListAction: (state, { payload }) => {},
    setPlanSubscriberUserListAction: (state, { payload }) => {
      state.planSubscriberUserList = payload;
    }
    
  },
});

const {
  getAllPlans,
  setAllPlans,
  getAllFeatures,
  setAllFeatures,
  updatePlans,
  updateSinglePlanAction,
  updatePlanResponse,
  updatePlanError,
  setNewPlanLocal,
  resetNewPlanLocal,
  updateNewPlanLocalField,
  getPlanSubscriberUserListAction,
  setPlanSubscriberUserListAction,
} = servicePlansSlice.actions;

export {
  getAllPlans,
  setAllPlans,
  getAllFeatures,
  setAllFeatures,
  updatePlans,
  updateSinglePlanAction,
  updatePlanResponse,
  updatePlanError,
  setNewPlanLocal,
  resetNewPlanLocal,
  updateNewPlanLocalField,
  getPlanSubscriberUserListAction,
  setPlanSubscriberUserListAction,
};

export default servicePlansSlice.reducer;
